import {useState} from "react";
import * as React from "react";
import {FormattedMessage} from "react-intl";
import './SelfTerminalFormHeader.css';
import {IconButton} from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';

export type SelfTerminalFormHeaderProps = {
    onBackHome: () => void;
};

const SelfTerminalFormHeader: React.FC<SelfTerminalFormHeaderProps> = (props) => {

    return (
        <div className="self-terminal-form-header" onClick={() => props.onBackHome()}>
            <img className="self-terminal-form-header-logo" src={'/logo.png'}/>
            <span style={{color: 'white'}}><FormattedMessage id='VMS_TERMINAL_WELCOME_TITLE'/></span>
            <IconButton onClick={() => props.onBackHome()}>
                <HomeIcon fontSize="inherit" sx={{color:'white'}}/>
            </IconButton>
        </div>
    )
};

export default SelfTerminalFormHeader;